import {
  Box,
  Grid,
  Typography,
  Button,
  Breadcrumbs,
  Link,
  Tooltip,
  Chip,
  Stack,
  IconButton,
  Divider,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchReasons,
  fetchXevmpdDataById,
  fetchFormFields,
  updatexEVMPDRecord,
  fetchGridFields,
  getSideMenuRecord,
  addSideMenuRecord,
  updateSideMenuRecord,
  fetchAllSideMenuData,
  fetchAcknowledgementByXevmpdId,
  downloadAckAttachment,
  fetchSideMenuDataById,
  addSideMenuRecordV2,
  updateSideMenuRecordV2,
  disableRelatedRecord,
  getGridDataById,
  fetchUAMpreveligies,
  getAuditInfo,
} from "../../api/apiFunctions";
import Cookies from "js-cookie";
import { useSnackbar } from "notistack";
import SideNavigation from "./SideNavigation";
import { useSideNavigation } from "../../hooks/useSideNavigation";
import Loading from "../../components/Loading";
import { DynamicFormCompBasicJsonSchema } from "@freyr/freyr-react-common";
import { XevmpdContext } from "../../App";
import { useDrawerContext } from "../../contexts/DrawerContext";
import {
  DataGridPremium,
  GridActionsCellItem,
  GridColDef,
  GridColumnVisibilityModel,
  GridRenderCellParams,
  GridRowParams,
  GridToolbar,
  GridValueFormatterParams,
} from "@mui/x-data-grid-premium";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditForm from "../../components/EditForm";
import {
  formatDate,
  getTruncatedName,
  GridColCommon,
  GridManagerFieldItem,
  isISODateString,
  sortFn,
  transformFormDataForReset,
} from "../../assets/utils";
import EditIcon from "@mui/icons-material/CreateOutlined";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ExcelIcon from "../../assets/images/excel-icon.jpg";
import PPTIcon from "../../assets/images/ppt-icon.jpg";
import WordIcon from "../../assets/images/word-icon.jpg";
import PDFIcon from "../../assets/images/pdf-icon.jpg";
import XMLIcon from "../../assets/images/xmi-icon.png";
import ZIPIcon from "../../assets/images/zip-icon.jpg";
import JSONIcon from "../../assets/images/json-icon.png";
import RTFIcon from "../../assets/images/rtf-icon.pgn.png";
import { useDataGridLocalText } from "../../hooks/useDataGridLocaleText";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import isEqual from "lodash/isEqual";
import NoRecordsFound from "../../components/NoRecordsFound";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeletexEVMPD from "./DeletexEVMPD";
import ProcessBarComponent from "../P&T/ProcessBarComponent";
import ProcessIconButton from "../P&T/ProcessIconButton";
import { useTaskResultProperty } from "../../hooks/useTaskResultProperty";
import { useAppCookies } from "../../assets/utils";
import CollapseMenuIcon from "../../assets/images/icon-side-menu-collapse.svg";
import ExpandMenuIcon from "../../assets/images/icon-side-menu-expand.svg";
import { getPrecessRelatedInfo } from "../P&T/workflow";
import CreationUpdateDetails from "../../components/CreationUpdateDetails";
import inprogressIcon from '../../assets/images/icon-lifecycle-inprogress.svg';
import style from "../P&T/index.module.scss";
import classNames from "classnames";




// ✅ New correct signature — accepts menuName + dependency object
export const loadSideMenuGridData = async (
  menuName: string,
  {
    fetchAllSideMenuData,
    handleForms,
    setSideGridColumns,
    setSideGridData,
    setLoading,
    intialformData,
    id,
  }: {
    fetchAllSideMenuData: (params: {
      name: string;
      xevmpdId: string | number;
      section: string;
    }) => Promise<any>;
    handleForms: (
      formName: string | null,
      mode: "add" | "edit" | "view",
      cellData: any
    ) => Promise<void>;
    setSideGridColumns: (cols: any[]) => void;
    setSideGridData: (rows: any[]) => void;
    setLoading: (val: boolean) => void;
    intialformData: any;
    id: string | number;
  }
): Promise<void> => {
  try {

    setLoading(true);

    const params = {
      name: menuName,
      xevmpdId: id,
      section: "Authorized Product",
    };
    const response = await fetchAllSideMenuData(params);

    const gridFieldList =
      response?.data?.data?.gridFieldList ||
      response?.data?.gridFieldList ||
      response?.gridFieldList ||
      [];

    const fieldDataList =
      response?.data?.data?.fieldDataList ||
      response?.data?.fieldDataList ||
      response?.fieldDataList ||
      [];

    if (menuName === "Attachments" && Array.isArray(fieldDataList)) {
      fieldDataList.forEach((item: any) => {
        const attachmentObj = item?.attachment || {};
        item.attachmentName = attachmentObj?.name || item?.attachmentName || "";
        item.attachmentType = attachmentObj?.type || item?.attachmentType || "";
        item.attachmentSize = attachmentObj?.size || item?.attachmentSize || "";
        item.eVCode =
          item?.eVCode ||
          item?.EVCode ||
          intialformData?.xevmpdData?.xevmpdFormData?.eVCode ||
          "";
      });
    }

    const gridColumns = gridFieldList
      ?.filter((col: any) => col.gridAvailability)
      ?.sort((a: any, b: any) => a.order - b.order)
      ?.map((col: any) => ({
        field: col.fieldName,
        headerName: col.column,
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <Tooltip title={String(params.value ?? "")} placement="bottom">
            <span>{String(params.value ?? "-")}</span>
          </Tooltip>
        ),
      }));

    const actionsColumn = {
      field: "actions",
      type: "actions",
      width: 90,
      headerName: "Actions",
      getActions: (params: any) => [
        <GridActionsCellItem
          key="view"
          showInMenu
          label="View"
          icon={<RemoveRedEyeIcon />}
          onClick={() => handleForms(menuName, "view", params.row)}
        />,
      ],
    };

const rowsWithIds = fieldDataList
  ?.filter((row: any) => {
    const entries = Object.entries(row);

    // Skip rows that only contain eVCode
    const hasOnlyEVCode =
      entries.length === 1 &&
      Object.prototype.hasOwnProperty.call(row, "eVCode");

    if (hasOnlyEVCode) return false;

    // Keep rows with at least one non-empty value
    return entries.some(
      ([, val]) => val !== "" && val !== null && val !== undefined
    );
  })
  ?.map((row: any, index: number) => ({
    id: row?.id ?? index + 1,
    ...row,
  }));

    setSideGridColumns([...gridColumns, actionsColumn]);
    setSideGridData(rowsWithIds);
  } catch (err) {
    console.error(`Failed to load ${menuName} grid:`, err);
    setSideGridColumns([]);
    setSideGridData([]);
  } finally {
    setLoading(false);
  }
};

// ✅ Standalone exportable handleForms — moved outside component
export const handleForms = async (
  deps: {
    id: any;
    xevmpdStatus: string;
    enqueueSnackbar: Function;
    setLoading: Function;
    setSideFormMode: Function;
    setActiveGridMenu: Function;
    setSideFormFields: Function;
    setSideMenuRecordId: Function;
    setSideFormData: Function;
    reset: Function;
    setOriginalSideFormData: Function;
    setShowEditForm: Function;
    setIsSideGrid: Function;
    structureUpdatedData: Function;
    setIsAssociatedGrid: Function;
    isAssociatedGrid: boolean;
    sectionName: string;
  },
  formName: string | null,
  mode: "add" | "edit" | "view",
  cellData: any
) => {
  const {
    id,
    xevmpdStatus,
    enqueueSnackbar,
    setLoading,
    setSideFormMode,
    setActiveGridMenu,
    setSideFormFields,
    setSideMenuRecordId,
    setSideFormData,
    reset,
    setOriginalSideFormData,
    setShowEditForm,
    setIsSideGrid,
    structureUpdatedData,
    isAssociatedGrid,
  } = deps;

  if (!formName) {
    enqueueSnackbar("Cannot open form. Try again", { variant: "error" });
    return;
  }

  try {
    setLoading(true);
    setSideFormMode(mode);
    setActiveGridMenu(formName);

    const params = { module: "xevmpd", formName };
    let fields = await fetchFormFields(params);

    fields.forEach((field: any) => {
      if (field.field === "status" && xevmpdStatus !== "Submitted") {
        field.options = field.options?.filter(
          (opt: any) => opt.value !== "Failed"
        );
      }
    });


    if (mode === "view" && formName === "Acknowledgements") {
      fields = fields.filter((f: any) => f.field !== "attachment");
    }

    setSideFormFields(fields || []);

    let fieldData: any = {};

    if (formName.trim().toLowerCase() === "acknowledgements" || isAssociatedGrid) {
      if (mode !== "add" && cellData?.id) {
        try {
          
          const response = await getSideMenuRecord(Number(cellData.id));
          setSideMenuRecordId(cellData.id);

          const relatedData = response?.xevmpdRelatedData
            ? typeof response.xevmpdRelatedData === "string"
              ? JSON.parse(response.xevmpdRelatedData || "{}")
              : response.xevmpdRelatedData
            : {};

          // if (!relatedData.attachment && formName==="Acknowledgements") {
          //   enqueueSnackbar("Attachment missing in Acknowledgement record.", {
          //     variant: "error",
          //   });
          //   setLoading(false);
          //   return;
          // }

          fieldData = transformFormDataForReset(cellData, fields, relatedData);
          console.log("FIELDDATA:",fieldData);
        } catch (error) {
          console.error("❌ Failed to fetch Acknowledgement record:", error);
          enqueueSnackbar("Failed to fetch Acknowledgement data", {
            variant: "error",
          });
        }
      } else if (mode === "add") {
        fieldData = fields.reduce((acc: any, f: any) => {
          acc[f.field] = "";
          return acc;
        }, {});
      }
    } else if (
      [
        "ATC Code(s)",
        "Product Indication",
        "Pharmaceutical Product",
        "Presentation Details",
        "Attachments",
      ].includes(formName)

    ) {
      const response = await getGridDataById(id, formName, cellData?.id-1);
      const fieldJson = response?.dynamicFieldJson
          ? JSON.parse(response.dynamicFieldJson)
          : [];
        setSideFormFields(fieldJson);

      fieldData = cellData ? { ...cellData } : {};
    } else if (
      ["Authorisation", "MAH", "Pharmacovigilance"].includes(formName)
    ) {
      try {
        const response = await fetchSideMenuDataById({
          name: formName,
          xevmpdId: id,
        });
        const fieldJson = response?.dynamicFieldJson
          ? JSON.parse(response.dynamicFieldJson)
          : [];
        const fieldDataResp = response?.fieldData || {};
        setSideFormFields(fieldJson);
        setSideFormData(fieldDataResp);
        reset(fieldDataResp);
      } catch (error) {
        console.error(`❌ Failed to load ${formName} data:`, error);
        enqueueSnackbar(`Failed to load ${formName} data`, {
          variant: "error",
        });
      }
    } else if (mode === "add") {
      fieldData = fields.reduce((acc: any, f: any) => {
        acc[f.field] = "";
        return acc;
      }, {});
    }
    

    fieldData = fields.reduce((acc: any, f: any) => {
      acc[f.field] = fieldData[f.field] ?? "";
      return acc;
    }, {});

    // if (formName === "Acknowledgements" && mode === "view") {
    //   const relatedAttachment = fieldData?.attachment;

    //   if (!relatedAttachment.name) {
    //     enqueueSnackbar("Attachment missing in Acknowledgement record.", {
    //       variant: "error",
    //     });
    //   } else {
    //     fieldData.attachment = relatedAttachment;
    //     fieldData.attachmentName = relatedAttachment.name;
    //   }

    //   // ✅ Always safe – no dependency on fieldDataResp
    //   setSideFormData({ ...fieldData });
    // }

    setSideFormData(fieldData);
    reset(fieldData);
    setOriginalSideFormData(structureUpdatedData(fieldData));

    setShowEditForm(false);
    setIsSideGrid(false);
    setSideFormMode(mode);
  } catch (error) {
    console.error(`❌ handleForms failed for ${formName}:`, error);
    enqueueSnackbar(`Failed to open ${formName}`, { variant: "error" });
  } finally {
    setLoading(false);
  }
};

export const syncEvCodeAcrossMenus = (
  intialformData: any,
  formValues: any,
  structureUpdatedData: Function
) => {
  const updatedMainForm = structureUpdatedData(formValues);
  const evCodeUpdated = updatedMainForm?.eVCode?.trim?.();

  if (!evCodeUpdated) return intialformData.xevmpdData.MenuData;

  // Deep clone menu data safely (avoid mutation)
  const syncedMenuData = structuredClone(
    intialformData?.xevmpdData?.MenuData || {}
  );

  const singleMenus = ["Authorisation", "Pharmacovigilance", "MAH"];
  const gridMenus = [
    "ATC Code(s)",
    "Product Indication",
    "Pharmaceutical Product",
    "Presentation Details",
    "Attachments",
  ];

  const updateRow = (row: any, menu: string) => ({
    ...row,
    eVCode: evCodeUpdated,
    // EVCode: evCodeUpdated,
    ...(menu === "Attachments" ? { attachmentEVCode: evCodeUpdated } : {}),
  });

  // ✅ Update single-object menus
  singleMenus.forEach((menu) => {
    const data = syncedMenuData[menu];
    if (!data) return;
    syncedMenuData[menu] = Array.isArray(data)
      ? data.map((r) => updateRow(r, menu))
      : updateRow(data, menu);
  });

  // ✅ Update or initialize grid menus
  gridMenus.forEach((menu) => {
    const rows = syncedMenuData[menu];
    if (!Array.isArray(rows) || rows.length === 0) {
      syncedMenuData[menu] = [updateRow({}, menu)];
    } else {
      syncedMenuData[menu] = rows.map((r) => updateRow(r, menu));
    }
  });

  return syncedMenuData;
};

export const waitForGridReadyBeforePrint = async () => {
  return new Promise<void>((resolve) => {
    const check = () => {
      const gridContainer =
        document.querySelector(".MuiDataGrid-virtualScroller") ||
        document.querySelector(".MuiDataGrid-printWindow") ||
        document.querySelector(".MuiDataGrid-root");

      if (gridContainer) {
        const rows = gridContainer.querySelectorAll(".MuiDataGrid-row");
        if (rows.length > 0) {
          resolve();
          return;
        }
      }
      requestAnimationFrame(check);
    };
    check();
  });
};

export const handleManualPrint = () => {
  const gridElement = document.querySelector(".MuiDataGrid-root");

  if (!gridElement) {
    console.error("Grid element not found for print");
    return;
  }

  const cloned = gridElement.cloneNode(true);

  // Create a hidden iframe
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow!.document;
  doc.open();
  doc.write(`
    <html>
    <head>
      <title>Print</title>
      <style>
        body { margin: 20px; }
        .MuiDataGrid-main { height: auto !important; overflow: visible !important; }
        .MuiDataGrid-virtualScroller { height: auto !important; }
      </style>
    </head>
    <body></body>
    </html>
  `);
  doc.close();

  doc.body.appendChild(cloned);

  // Wait for layout, then print
  setTimeout(() => {
    iframe.contentWindow!.focus();
    iframe.contentWindow!.print();
    document.body.removeChild(iframe);
  }, 300);
};

const EditxEVMPD: React.FC = () => {
  const { privileges,setPrivileges, allXevmpdRows,processRelatedInfo,setProcessRelatedInfo } = useContext(XevmpdContext);
  const { processDrawerOpen,setProcessDrawerOpen} = useDrawerContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const isEdit = location.pathname.includes("edit-xevmpd/");
  const [recordIDForBreadCrumbs, setRecordIDForBreadCrumbs] = useState("");
  const {recordId} = useParams();
  const initialMode = isEdit ? "edit" : location?.state?.mode || "view"; // 'view' or 'edit'
  const id =  recordId ? recordId : location?.state?.params?.xevmpdId;
  const { enqueueSnackbar } = useSnackbar();
  const { userID } = useAppCookies();
  
  // Fetch task result property
  const { data: taskButtonConfig } = useTaskResultProperty(id, userID);
  const processAssociationId = taskButtonConfig?.processAssociationId;
  const processJudge = taskButtonConfig?.processJudge;
  const processTemplateName = taskButtonConfig?.processTemplateName;

  const [gridFields, setGridFields] = useState([]);
  const [viewOrEditPage, setViewOrEditPage] = useState(true);
  const { localeText } = useDataGridLocalText();
  const {
    watch,
    control,
    formState: { errors },
    clearErrors,
    trigger,
    setError,
    setValue,
    reset,
    register,
  } = useForm<any>({
    // Use 'any' for dynamic fields
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });

  const {
    sideMenus,
    sideMenuData,
    loading,
    pageTitle,
    onSideMenuChange,
    paramss,
    setPageTitle,
    setLoading,
  } = useSideNavigation();

  const [showEditForm, setShowEditForm] = useState(true);
  const [formMode, setFormMode] = useState<"view" | "edit">(initialMode);
  const [formFields, setFormFields] = useState<any>(undefined);
  const [intialformData, setIntialFormData] = useState<any>({});
  const [xevmpdData, setXevmpdData] = useState<any>({});
  const [isExpand, setIsExpand] = useState(false);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});
  const [sideFormFields, setSideFormFields] = useState<any[]>([]);
  const [sideFormMode, setSideFormMode] = useState<
    "add" | "edit" | "view" | null
  >(null);
  const [sideFormData, setSideFormData] = useState<any>({});
  const [activeGridMenu, setActiveGridMenu] = useState<string | null>(null);
  const [sideMenuRecordId, setSideMenuRecordId] = useState("");
  const [isFormModified, setIsFormModified] = useState(false);
  const [AckRows, setAckRows] = useState<[]>([]);
  const [acktrigger, setacktrigger] = useState(true);
  const [showNavigationConfirm, setShowNavigationConfirm] = useState(false);
  const [navigateToOtherMenu, setNavigateToOtherMenu] = useState(false);
  const revertSelectionRef = useRef<(() => void) | null>(null);
  const [sideGridData, setSideGridData] = useState<any[]>([]);
  const [sideGridColumns, setSideGridColumns] = useState<any[]>([]);
  const [isSideGrid, setIsSideGrid] = useState(false);
  const [originalSideFormData, setOriginalSideFormData] = useState<any>({});
  const [xevmpdStatus, setXevmpdStatus] = useState<string>("");
  const [openDisableDialog, setOpenDisableDialog] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [isGridReady, setIsGridReady] = useState(false);
  const [details,setDetails]=useState<any>({});

  const [applicationEditable,setApplicationEditable]=useState(true);

    const displayProcessTemplateName = () => {
    return (
      !!processTemplateName &&
      (processJudge === "IN_PROGRESS" || processJudge === "NOT_STARTED")
    );
  };
  
useEffect(() => {
  const fetchData = async () => {
    
    if (processAssociationId && processJudge === "IN_PROGRESS") {
      setLoading(true);
      const response = await getPrecessRelatedInfo(id, userID);
      
     if ((response?.data as any)?.code === 200) {
          const processData = (response.data as any).data;
          setProcessRelatedInfo(processData);
        setApplicationEditable?.(processData.applicationEditable);
      }
      setLoading(false);
    }
  };
  fetchData();
}, [processAssociationId, processJudge]);

 const loadPrivileges = async () => {
    const privileges = await fetchUAMpreveligies();

    const privilegeNames = privileges.map(
      (prenameobj: any) => prenameobj.name
    );

    setPrivileges({
      viewprivilege: privilegeNames.includes('view_xevmpd'),
      editprivilege: privilegeNames.includes('edit_xevmpd'),
      addprivilege: privilegeNames.includes('Add_xevmpd'),
      deleteprivilege: privilegeNames.includes('delete_xevmpd'),
      addackprevilege: privilegeNames.includes('Add_ACK'),
    });
  };


  const getAuditDetails = async () => {
    const response = await getAuditInfo(id);
    setDetails({
      createdBy:response?.createdByName,
      createdDate:response?.createdDate,  
      updatedBy:response?.modifiedByName,
      updatedDate:response?.modifiedDate
    })
    console.log("Audit details response:", response);
  }
  useEffect(() => { 
  getAuditDetails();
  loadPrivileges();
}, []);

  useEffect(() => {
    if (sideGridData.length && sideGridColumns.length) {
      const timer = setTimeout(() => setIsGridReady(true), 500);
      return () => clearTimeout(timer);
    } else {
      setIsGridReady(false);
    }
  }, [sideGridData, sideGridColumns]);

  const isNotDraftState = ![undefined, null, "Draft"].includes(
    watch("xEVMPDStatus.value")
  );
  const [pendingNavigation, setPendingNavigation] = useState<any>(null);
  const [menuAndSectionDetails, setMenuAndSectionDetails] = useState<{
    menuName: string;
    sectionName: string;
  }>({
    menuName: "Acknowledgements",
    sectionName: "Acknowledgements"
  });
  const [isAssociatedGrid, setIsAssociatedGrid] = useState(false);


  const isViewOnlyMenu = (menuName: string) => {
    if (menuName !== "xEVMPD" && menuName !== "Acknowledgements") return true;

    return initialMode !== "edit";
  };

  const getAllUniqueKeys = (obj1: any, obj2: any): string[] => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    const allKeys: string[] = [];

    keys1.forEach((key) => {
      if (!allKeys.includes(key)) allKeys.push(key);
    });

    keys2.forEach((key) => {
      if (!allKeys.includes(key)) allKeys.push(key);
    });

    return allKeys;
  };

  // Separate comparison logic method
 const checkFormChanges = (formValues: any, originalData: any): boolean => {
  if (!formValues || Object.keys(formValues).length === 0) {
    return false;
  }

  const updatedFormValues = structureUpdatedData(formValues);
  const allKeys = getAllUniqueKeys(originalData, updatedFormValues)
    .filter((key) => key !== 'recordID');

  return allKeys.some(
    (key) =>
      !isEqual(
        originalData[key] ?? "",
        updatedFormValues[key] ?? ""
      )
  );
};

  const [sectionName, setSectionName] = useState("Acknowledgements");

  // Updated checkForModifications method
  const checkForModifications = (node: any, parentName: string | undefined) => {
    setGridFields([]);
    setSectionName(parentName || "Acknowledgements");
    setPendingNavigation(node);

     //navigation check for form(non-grid) menus
    if(isFormFlag){
      const formValues=watch();
      console.log("FormValues:",structureUpdatedData(formValues),originalSideFormData);
      const hasChanges = checkFormChanges(structureUpdatedData(formValues),originalSideFormData);
      if(hasChanges)
        setShowNavigationConfirm(true);
      else
      setNavigateToOtherMenu(true);
      return;
    }
    const navigatingToXEVMPD = node.name === "xEVMPD";
    const editingXEVMPD = pageTitle === "xEVMPD" && formMode === "edit";
    const editingAck =
      pageTitle !== "xEVMPD" &&
      sideFormMode === "edit" &&
      checkFormChanges(structureUpdatedData(watch()), originalSideFormData);

    checkFormChanges(structureUpdatedData(watch()), originalSideFormData);

    // ✅ Case 1: Currently editing xEVMPD → prompt when leaving
    if (editingXEVMPD && !navigatingToXEVMPD) {
      const updatedValues = structureUpdatedData(watch());
      const hasChanges = checkFormChanges(
        updatedValues,
        intialformData.xevmpdData.xevmpdFormData
      );

      if (hasChanges) {
        return setShowNavigationConfirm(true);
      }

      setIsFormModified(false);
      return setNavigateToOtherMenu(true);
    }

    // ✅ Case 2: Currently editing Acknowledgements → prompt when leaving Acknowledgements
    if (editingAck && pageTitle !== node.name) {

      const hasChanges = checkFormChanges(
        structureUpdatedData(watch()),
        originalSideFormData
      );
      return hasChanges
        ? setShowNavigationConfirm(true)
        : setNavigateToOtherMenu(true);
    }

    // ✅ Case 3: Navigating into xEVMPD → Allow silently (✅ FIX)
    if (navigatingToXEVMPD) {
      setSideFormMode(null);
      return setNavigateToOtherMenu(true);
    }

    // ✅ Default → Just navigate
    setNavigateToOtherMenu(true);
  };

  useEffect(() => {
    setIsFormModified(false); // Reset when loading new data or switching modes
  }, [formMode, sideFormMode, xevmpdData, sideFormData]);

  useEffect(() => {
    if (navigateToOtherMenu) {
      setMenuAndSectionDetails({
        menuName: pendingNavigation.name,
        sectionName: sectionName,
      });

      handleMenuChange(pendingNavigation);
    }
  }, [navigateToOtherMenu, pendingNavigation]);

  const [isFormFlag, setIsFormFlag] = useState(false);

  const handleMenuChange = async (node: any) => {
    setIsGridReady(false);
    setIsFormFlag(false);
    setIsAssociatedGrid(false);
    setActiveGridMenu(null);
    setSideFormMode(null);

    setLoading(true);
    setPageTitle(node.name);

    // 🟢 These are the new side grid menus
    const gridMenus = [
      "Presentation Details",
      "ATC Code(s)",
      "Product Indication",
      "Pharmaceutical Product",
      "Attachments",
    ];
    node.name === "xEVMPD"?setViewOrEditPage(true):setViewOrEditPage(false);
    if (node.name === "xEVMPD") {
      clearErrors();
      await loadData(); // ✅ ensures intialformData refreshed

      // ✅ Delay reset until dropdown fields are ready
      if (formFields?.length > 0) {
        reset(
          transformFormDataForReset(
            intialformData?.xevmpdData?.xevmpdFormData || {},
            formFields
          )
        );
      } else {
        // ✅ Fallback: perform reset once formFields arrive (for refresh case)
        Promise.resolve().then(() => {
          const interval = setInterval(() => {
            if (formFields?.length > 0) {
              reset(
                transformFormDataForReset(
                  intialformData?.xevmpdData?.xevmpdFormData || {},
                  formFields
                )
              );
              clearInterval(interval);
            }
          }, 100);
        });
      }

      setShowEditForm(true);
      setActiveGridMenu(null);
      setIsSideGrid(false);
      setSideFormMode(null);
      setNavigateToOtherMenu(false);
    }
    // ✅ Case 2: Handle the 5 new grids
    else if (gridMenus.includes(node.name)) {
      setShowEditForm(false);
      setActiveGridMenu(node.name);
      setIsSideGrid(true);
      await loadSideMenuGridData(node.name, {
        fetchAllSideMenuData,
        handleForms: handleFormsWrapper,
        setSideGridColumns,
        setSideGridData,
        setLoading,
        intialformData,
        id,
      });
    }
    // ✅ Case 3: Acknowledgements → keep your existing working logic intact
    else if (node.associatedGrid) {
      setShowEditForm(false);
      setActiveGridMenu(node.name);
      setIsSideGrid(false);
      setIsAssociatedGrid(true);
      await onSideMenuChange(node);
      // await getSideMenuGridData();
    }
    // ✅ NEW CASE: Dynamically created form menus (non-grid menus)
    else if (!node.associatedGrid && sectionName !== "Authorised Product") {
      setIsFormFlag(true);
      setShowEditForm(false);
      setActiveGridMenu(node.name);
      setIsSideGrid(false);

      try {
        // Check if form data already exists using fetchAcknowledgementByXevmpdId
        const menuAndSection = {
          menuName: node.name,
          sectionName: sectionName
        };
        
        const response = await fetchAcknowledgementByXevmpdId(id, menuAndSection);
        const ackData = response?.data || [];

        // Get form fields
        const params = { module: "xevmpd", formName: node.name };
        const fields = await fetchFormFields(params);
        setSideFormFields(fields || []);

        if (ackData.length > 0) {
          // Data exists → Edit mode
          // Get the first record (assuming single record per menu for form menus)
          const recordDetails = await getSideMenuRecord(ackData[0].id);
          const firstRecord = ackData[0];
          
          const relatedData = firstRecord?.xevmpdRelatedData
            ? typeof firstRecord.xevmpdRelatedData === "string"
              ? JSON.parse(firstRecord.xevmpdRelatedData || "{}")
              : firstRecord.xevmpdRelatedData
            : {};

          setSideMenuRecordId(recordDetails.id);
          setSideFormMode("edit");
          setSideFormData(relatedData);
          reset(transformFormDataForReset(relatedData,fields,recordDetails.xevmpdRelatedData));

          // Store original data for change detection
          setOriginalSideFormData(structureUpdatedData(recordDetails.xevmpdRelatedData));
        } else {
          // No data → Add mode
          setSideFormMode("add");
          const emptyData = fields.reduce((acc: any, f: any) => {
            acc[f.field] = "";
            return acc;
          }, {});
          setSideFormData(emptyData);
          reset(emptyData);
          setOriginalSideFormData({});
        }

        setActiveGridMenu(node.name);
      } catch (error) {
        console.error(`❌ Failed to load ${node.name} form data:`, error);
        // If fetch fails, assume Add mode
        setSideFormMode("add");

        // Try to get fields from API
        try {
          const params = { module: "xevmpd", formName: node.name };
          const fields = await fetchFormFields(params);
          setSideFormFields(fields || []);

          const emptyData = fields.reduce((acc: any, f: any) => {
            acc[f.field] = "";
            return acc;
          }, {});
          setSideFormData(emptyData);
          reset(emptyData);
          setOriginalSideFormData({});
        } catch (fieldError) {
          console.error(`❌ Failed to fetch fields for ${node.name}:`, fieldError);
          enqueueSnackbar(`Failed to load ${node.name} form`, { variant: "error" });
        }
      }
    }
    // ✅ Case 4: Predefined single-form menus (Authorisation, MAH, Pharmacovigilance)
    else {
      setShowEditForm(false);
      await onSideMenuChange(node);
      setActiveGridMenu(null);
      setIsSideGrid(false);
    }

    // ✅ Set view or edit mode
    if (isViewOnlyMenu(node.name)) {
      setFormMode("view");
    } else {
      setFormMode("edit");
    }

    setLoading(false);
    setNavigateToOtherMenu(false);
  };

  const loadData = async () => {
    // setLoading(true);
    const getFormData = await fetchXevmpdDataById(id);
    console.log("Fetched xEVMPD data:", getFormData.createdBy,getFormData.createdDate); 
    const statusFromForm =
      getFormData?.xevmpdData?.xevmpdFormData?.xevmpdStatus || "";
    setRecordIDForBreadCrumbs(getFormData?.xevmpdData?.recordID || "");
    setXevmpdStatus(statusFromForm);


    const isOrange = getFormData?.xevmpdStatus === 2; //  2 for Oarange   ,  0 for Green  , not 0  then it is green

    let parsedXevmpdData: any = {};
    try {
      parsedXevmpdData = getFormData?.xevmpdData;
    } catch (err) {
      console.error("Failed to parse xevmpdData:", err);
    }

    // If status = 3, enrich reasonToDisable with label
    if (getFormData?.xevmpdStatus === 3) {
      const reasons = await fetchReasons();
      const foundReason = reasons.find(
        (reason: any) =>
          reason.id === parsedXevmpdData?.xevmpdFormData?.reasonToDisable
      )?.name;
      if (foundReason) {
        parsedXevmpdData = {
          ...parsedXevmpdData,
          xevmpdFormData: {
            ...parsedXevmpdData.xevmpdFormData,
            reasonToDisable: foundReason,
           // replace with full object
          },
        };
      }
    }

    // set initial form data
    setIntialFormData({
      ...getFormData,
      xevmpdData: parsedXevmpdData,
    });
    setXevmpdData(getFormData.xevmpdData.xevmpdFormData);

    // fetch fields
    const params = { module: "xevmpd", formName: "xEVMPD" };
    const gridFields = await fetchFormFields(params);
    let formFields = gridFields
      ?.filter((gridField: any) => gridField?.edit_xevmpd)
      .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0));

    if (isOrange) {
      formFields = formFields.map((field: any) => {
        if (field.field === "xevmpdStatus") {
          return { ...field, disabled: true };
        }
        return field;
      });
    }

   const recordID = getFormData?.xevmpdData?.recordID || "";

// First reset
const formDataToReset = transformFormDataForReset(
  { ...parsedXevmpdData.xevmpdFormData, recordID },  // ✅
  formFields
);

    // Reset form with dynamic data

    reset(formDataToReset);

    // Dynamically register all fields for validation

    formFields.forEach((field: any) => {
      if (field.required && !field.disabled) {
        register(field.field, {
          required: `${field.label || field.field} is required`,
        });
      }
    });


    // add extra fields only if status = 3
    if (getFormData?.xevmpdStatus === 3) {
      formFields.push(
        {
          field: "reasonToDisable",
          label: "Reason for Delete",
          required: true,
          readonly: false,
          disabled: false,
          description: "",
          hide: false,
          icon: [],
          field_xs: 12,
          field_xl: 12,
          field_md: 12,
          field_lg: 12,
          originlabel: "Reason for Disable",
          systemDefault: false,
          type: "text",
          order: 99,
        },
        {
          field: "commentsOnDisable",
          label: "Delete Comments",
          readonly: false,
          disabled: false,
          description: "",
          hide: false,
          icon: [],
          field_xs: 12,
          field_xl: 12,
          field_md: 12,
          field_lg: 12,
          originlabel: "Disable Comments",
          systemDefault: false,
          type: "text",
          order: 100,
        }
      );
    }

    setFormFields(formFields);
    if (formMode === "edit" && parsedXevmpdData?.xevmpdFormData) {
     if (formMode === "edit" && parsedXevmpdData?.xevmpdFormData) {
  const formDataToReset = transformFormDataForReset(
    { ...parsedXevmpdData.xevmpdFormData, recordID }, 
    formFields
  );
  reset(formDataToReset);
  setXevmpdData(parsedXevmpdData.xevmpdFormData);
}

      reset(formDataToReset); 
      setXevmpdData(parsedXevmpdData.xevmpdFormData);
    }
    // setLoading(false);
  };

  const getgridfields = async () => {

    const params = { module: "xevmpd", gridName: menuAndSectionDetails?.menuName || "" };
    const gridFields = await fetchGridFields(params);
    if (!gridFields) return;
    const gridColumnKey = {
      ...columnVisibilityModel,
    };
    gridFields
      ?.filter((item: GridManagerFieldItem) => item.gridAvailability)
      ?.forEach((item: GridManagerFieldItem) => {
        const key: string = item.fieldName;
        gridColumnKey[key] = item.visibility;
      });
    setColumnVisibilityModel({
      ...gridColumnKey,
    });
    setGridFields(gridFields);
  };

  const getSideMenuGridData = async () => {
    // setLoading(true);
    const acknowdata = await fetchAcknowledgementByXevmpdId(id, menuAndSectionDetails);
    let parsedArray = acknowdata.data.map(
      (item: { xevmpdRelatedData: any }) => {
        const related = JSON.parse(item.xevmpdRelatedData || "{}");
        return {
          ...item,
          ...related,
          xevmpdRelatedData: undefined,
        };
      }
    );
    parsedArray = parsedArray.map((item:any) => ({
  ...item,
  attachment: {
    ...item.attachment,
    name: item.xevmpdRelatedStorageMetaInfo 
      ? `${item.xevmpdRelatedStorageMetaInfo.fileName}.${item.xevmpdRelatedStorageMetaInfo.fileType}`
      : (item.attachment?.name || '')
  }
}));
    console.log("PARSED ARRAY:",parsedArray);
    setAckRows(parsedArray);
    // setLoading(false);
  };
  useEffect(() => {
    getSideMenuGridData();
  }, [acktrigger]);

  useEffect(() => {
    const initialize = async () => {
      if (!isAssociatedGrid)
        return;
      setLoading(true);
      try {
        await loadData();
        await getgridfields();           // Columns first
        await getSideMenuGridData();     // Then data
      } finally {
        setLoading(false);
      }
    };
    initialize();
  }, [menuAndSectionDetails]);


  // ✅ Ensure fonts are loaded before enabling print/export
  useEffect(() => {
    document.fonts.ready.then(() => {
      setIsGridReady(true);
    });
  }, []);

  const actionsColumn: GridColDef<GridColCommon>[] = React.useMemo(
    () => [
      {
        field: "actions",
        type: "actions",
        width: 90,
        headerName: "Actions",
        getActions: (cell: GridRowParams) => {
          const actions: React.ReactElement[] = [];
          if (String(cell.id).includes("auto-generated-row")) {
            return actions; // Return empty actions if condition is met
          }
          if (initialMode === "edit") {
            actions.push(
              <GridActionsCellItem
                key="edit"
                showInMenu
                label="Edit"
                icon={<EditIcon />}
                onClick={() => {
                  handleFormsWrapper(activeGridMenu ?? "", "edit", cell.row);
                }}
              />
            );
          }

          actions.push(
            <GridActionsCellItem
              key="view"
              showInMenu
              label="View"
              icon={<RemoveRedEyeIcon />}
              onClick={() => {
                handleFormsWrapper(activeGridMenu ?? "", "view", cell.row);
                // setSideFormMode("view");
              }}
            />
          );
          if (activeGridMenu !== "Acknowledgements")
            actions.push(
              <GridActionsCellItem
                key="disable"
                showInMenu
                label="Delete"
                icon={<DeleteOutlineIcon />}
                onClick={() => {
                  handleDisable(cell.row.id);

                }}
              />
            );

          if (activeGridMenu === "Acknowledgements")
            actions.push(
              <GridActionsCellItem
                key="downloadAttachment"
                showInMenu
                label="Download Attachment"
                icon={<FileDownloadIcon />}
                onClick={() => handleDownloadAttachment(cell.id)}
              />
            );

          return actions;
        },
      },
    ],
    [
      privileges.editprivilege,
      privileges.viewprivilege,
      privileges.deleteprivilege,
      navigate,
      activeGridMenu,
    ]
  ); // Add all dependencies

  const handleDisable = React.useCallback(
    (id: any) => {
      setOpenDisableDialog(true);
      setSelectedId(id);
    },
    [setSelectedId]
  );
  const columns: GridColDef[] = React.useMemo(() => {
    const baseColumnConfig = {
      minWidth: 150,
      flex: 1,
    };

    const formatCellValue = (value: any) => {
      if (value === null || value === undefined || value === "") return "";
      if (isISODateString(value)) return formatDate(value);
      if (Array.isArray(value)) return value.join(", ");
      return value;
    };

    const dynamicColumns =
      gridFields
        ?.sort(sortFn)
        ?.filter(
          (item: GridManagerFieldItem) =>
            item.gridAvailability && item.fieldName !== "attachmentName"
        )
        ?.map((item: GridManagerFieldItem) => {
          const headerName = item.column;

          if (item.fieldName === "status") {
            return {
              ...baseColumnConfig,
              field: item.fieldName,
              headerName,
              renderCell: (cellValues: GridRenderCellParams) => {
                const status = cellValues.row.status;
                return status ? <Chip label={status} size="small" /> : null;
              },
            };
          }
          
          if (item.fieldName === "attachment") {
            return {
              ...baseColumnConfig,
              field: item.fieldName,
              headerName,
              valueFormatter: (params: GridValueFormatterParams) => {
                    const attachment = params.value;
                    return attachment?.name || '-';
                },
              renderCell: (cellValues: GridRenderCellParams) => {
                const attachment = cellValues.value; // { name, size, type, rawFile }
                const fileName = attachment?.name || "-";
                if(fileName==="-"){
                  
                }

                // Determine icon based on file extension
                let iconSrc;
                if (fileName.endsWith(".pdf")) iconSrc = PDFIcon;
                else if (
                  fileName.endsWith(".doc") ||
                  fileName.endsWith(".docx")
                )
                  iconSrc = WordIcon;
                else if (
                  fileName.endsWith(".xls") ||
                  fileName.endsWith(".xlsx")
                )
                  iconSrc = ExcelIcon;
                else if (
                  fileName.endsWith(".ppt") ||
                  fileName.endsWith(".pptx")
                )
                  iconSrc = PPTIcon;
                else if (fileName.endsWith(".xml")) iconSrc = XMLIcon;
                else if (fileName.endsWith(".json")) iconSrc = JSONIcon;
                else if (fileName.endsWith(".zip")) iconSrc = ZIPIcon;
                else if (fileName.endsWith(".rtf")) iconSrc = RTFIcon;
                else iconSrc = null; // fallback or default icon

                return (
                  <Tooltip title={fileName} placement="bottom">
                    <Box display="flex" alignItems="center" gap={1}>
                      {iconSrc && (
                        <img
                          src={iconSrc}
                          alt="file-icon"
                          style={{ width: 16, height: 16 }}
                        />
                      )}
                      <span>{fileName}</span>
                    </Box>
                  </Tooltip>
                );
              },
            };
          }

          return {
            ...baseColumnConfig,
            field: item.fieldName,
            headerName,
            renderCell: (cellValues: GridRenderCellParams) => {
              const formattedValue = formatCellValue(cellValues.value);
              return (
                <Tooltip title={formattedValue} placement="bottom">
                  <div>{formattedValue ? formattedValue : "-"}</div>
                </Tooltip>
              );
            },
          };
        }) || [];
    return [...dynamicColumns, ...actionsColumn];
  }, [gridFields, actionsColumn]); // Add dependencies

  const handleDownloadAttachment = async (id: any) => {

    setLoading(true);
    const response = await downloadAckAttachment(id);
    if (response.success)
      enqueueSnackbar(`${response.fileName} downloaded successfully.`, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    setLoading(false);
    return response;
  };


  const isSavingRef = useRef(false);

  const structureUpdatedData = (formValues: any) => {
  const hasValueProperty = (obj: unknown): obj is { value: unknown } => {
    return typeof obj === "object" && obj !== null && "value" in obj;
  };

  const hasLabelAndValueProperties = (obj: unknown): obj is { label: unknown; value: unknown } => {
    return typeof obj === "object" && obj !== null && "label" in obj && "value" in obj;
  };

  return Object.entries(formValues).reduce(
    (acc, [key, value]) => {
      let formattedDate;

      // Only format if the value is explicitly a Date object or Dayjs object
      if (value instanceof Date) {
        formattedDate = dayjs(value).format("DD/MMM/YYYY");
      } else if (dayjs.isDayjs(value)) {
        formattedDate = value.format("DD/MMM/YYYY");
      }

      // Handle arrays (for multi-select fields)
      if (Array.isArray(value)) {
        if (value.length === 0) {
          acc[key] = [];
        } else {
          // Check if it's an array of objects with label/value properties
          const allHaveLabelAndValue = value.every(item => 
            hasLabelAndValueProperties(item)
          );
          
          if (allHaveLabelAndValue) {
            // Extract just the values from the array of objects
            acc[key] = value.map(item => item.value);
          } else {
            // Keep the array as-is (could be array of strings, numbers, etc.)
            acc[key] = value;
          }
        }
      } 
      // Handle single object with value property (for single select fields)
      else if (value &&
          typeof value === "object" &&
          !(value instanceof Date) &&
          hasValueProperty(value)) {
        acc[key] = value.value;
      }
      // Handle date formatting
      else if (formattedDate) {
        acc[key] = formattedDate;
      }
      // Keep other values as-is
      else {
        acc[key] = value;
      }
      
      return acc;
    },
    {} as Record<string, any>
  );
};

  const handleSave = async (closeAfterSave = false) => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;

    clearErrors();
    const formValues = watch();

    const isValid = await trigger();
    if (!isNotDraftState && !isValid) {
      enqueueSnackbar("Fill all the required fields", { variant: "error" });
      isSavingRef.current = false;
      return;
    }
    const updatedFormValues = structureUpdatedData(formValues);
    const originalFormData = intialformData?.xevmpdData?.xevmpdFormData || {};
    const hasChanges = checkFormChanges(updatedFormValues, originalFormData);

    // setIsFormModified(!hasChanges);
    const successToastOptions = {
      variant: "success" as const,
      anchorOrigin: { vertical: "top" as const, horizontal: "center" as const },
    };

    if (!hasChanges) {
      isSavingRef.current = false;
      enqueueSnackbar("xEVMPD updated successfully", successToastOptions);
      if (closeAfterSave) {
        navigate("/xevmpd");
      }
      return;
    }

    const syncedMenuData = syncEvCodeAcrossMenus(
      intialformData,
      formValues,
      structureUpdatedData
    );

    const updatedMainForm = structureUpdatedData(formValues);
    const finalPayload = {
      ...intialformData,
      xevmpdData: {
        ...intialformData.xevmpdData,
        MenuData: syncedMenuData,
        xevmpdFormData: {
          ...intialformData.xevmpdData.xevmpdFormData,
          ...updatedMainForm,
        },
      },
      xevmpdStatus:
        updatedMainForm.xevmpdStatus === "Submitted"
          ? 1
          : intialformData.xevmpdStatus,
      updatedBy: Cookies.get("USER_EMAIL"),
      updated_date: new Date().toISOString(),
    };

    try {
      const response = await updatexEVMPDRecord(id, finalPayload, false);
      if (response.status === 200) {
        enqueueSnackbar("xEVMPD updated successfully", successToastOptions);
        if (closeAfterSave) {
          navigate("/xevmpd");
        } else {
          await loadData();
        }
      }
    } finally {
      isSavingRef.current = false;
      getAuditDetails();
    }
  };

  const getDefaultSideFormValues = () => ({
    status: undefined,
    acknowledgements: undefined,
    acknowledgementsType: undefined,
    ackComments: undefined,
    ackStatusDate: undefined,
    attachment: undefined,
    attachmentName: "",
  });

  // ✅ Updated handleSideFormCancel — reloads grid menus after cancel
  const handleSideFormCancel = async () => {
    // Preserve your existing reset logic
    setSideFormMode(null);
    setSideFormData({});
    reset(getDefaultSideFormValues());

    // ✅ Reload grid data for grid-based menus
    if (
      [
        "Presentation Details",
        "ATC Code(s)",
        "Product Indication",
        "Pharmaceutical Product",
        "Attachments",
      ].includes(pageTitle)
    ) {
      try {
        await loadSideMenuGridData(pageTitle, {
          fetchAllSideMenuData,
          handleForms: handleFormsWrapper,
          setSideGridColumns,
          setSideGridData,
          setLoading,
          intialformData,
          id,
        });

        // ✅ Make sure grid becomes visible again
        setIsSideGrid(true);

      } catch (error) {
        console.error(
          `❌ Failed to reload ${pageTitle} grid after cancel:`,
          error
        );
      }
    }
  };

  const savingRef = useRef(false);

  const handleSaveSideMenuData = async (
    originalData: any,
    closeAfterSave = false
  ) => {
    if (savingRef.current) return;
    savingRef.current = true;

    try {
      clearErrors();
      const formValues = watch();



      if (!isNotDraftState) {
        // 1. Target required side menu fields explicitly
        const sideFieldNames = sideFormFields
          .filter(f => f.required)
          .map(f => f.field);

        // 2. Wait a tick for async dropdowns to load
        await new Promise(resolve => setTimeout(resolve, 100));

        // 3. Trigger validation on required fields ONLY
        const isValid = await trigger(sideFieldNames as any);

        if (!isValid) {
          enqueueSnackbar("Fill all the required fields", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
          return;
        }
      }

      const updatedFormValues = structureUpdatedData(formValues);
      const originalFormData = structureUpdatedData(originalSideFormData);

      const hasChanges = checkFormChanges(updatedFormValues, originalFormData);
      // setIsFormModified(!hasChanges);
      if (!hasChanges && sideFormMode === "edit") {
        if (isFormFlag) {
          setOriginalSideFormData(structureUpdatedData(updatedFormValues));
          setSideFormMode("edit");
        } else if (closeAfterSave) {
          setSideFormMode(null);
        }

        enqueueSnackbar("Record updated successfully", { variant: "success" });
        return;
      }
      setLoading(true);

      const sideFieldNames = sideFormFields.map((f) => f.field);
      const sideFormData: Record<string, any> = {};
      Object.entries(formValues).forEach(([key, value]) => {
  let formattedValue;

  if (dayjs.isDayjs(value)) {
    formattedValue = value.format("DD/MMM/YYYY");
  } else if (value instanceof Date) {
    formattedValue = dayjs(value).format("DD/MMM/YYYY");
  } else if (value instanceof File) {
    // keep raw File as-is
    formattedValue = value;
  } else if (Array.isArray(value)) {
    // Handle array values - extract only the value property if objects exist
    formattedValue = value.map((item) => {
      if (item && typeof item === "object" && "value" in item) {
        return item.value; // Extract value property
      }
      return item; // Already a primitive value
    });
  } else if (value && typeof value === "object") {
    // for single objects, pick `value.value` if exists
    formattedValue = "value" in value ? value.value : value;
  } else {
    formattedValue = value;
  }

  if (sideFieldNames.includes(key)) sideFormData[key] = formattedValue;
});

      if (
        activeGridMenu === "Acknowledgements" &&
        (updatedFormValues.status === "Failed" ||updatedFormValues.status === "Acknowledgement Failed")
      ) {
        try {
          // 1️⃣ Fetch current xEVMPD
          const xevmpdRecord = await fetchXevmpdDataById(id);


          const currentVersion = parseFloat(
            xevmpdRecord?.xevmpdData?.xevmpdFormData?.version ?? 0
          );

          // Only update version if current status is NOT Draft
          let nextVersion = currentVersion;
          const currentStatus =
            xevmpdRecord?.xevmpdData?.xevmpdFormData?.xevmpdStatus;

          if (String(currentStatus).toLowerCase() !== "draft") {
            nextVersion = Number((currentVersion + 0.1).toFixed(1));
          }

          // 2️⃣ Prepare payload
          const updatedXevmpdPayload = {
            ...xevmpdRecord,
            xevmpdStatus: 0,
            xevmpdData: {
              ...xevmpdRecord.xevmpdData,
              xevmpdFormData: {
                ...xevmpdRecord.xevmpdData.xevmpdFormData,
                version: nextVersion,
                xevmpdStatus: "Draft",
              },
            },
            updatedBy: Cookies.get("USER_EMAIL"),
            updated_date: new Date().toISOString(),
          };

          console.log(
            "Prepared xEVMPD update payload before saving acknowledgement:",
            updatedXevmpdPayload
          );

          const updateResponse = await updatexEVMPDRecord(
            id,
            updatedXevmpdPayload,
            false
          );


          if (updateResponse?.status === 200) {
            enqueueSnackbar(`xEVMPD updated Successfully`, {
              variant: "success",
              anchorOrigin: { vertical: "top", horizontal: "center" },
            });
            const statusLabel =
              updatedXevmpdPayload.xevmpdData.xevmpdFormData.xevmpdStatus ??
              "Draft";

            setXevmpdStatus(statusLabel);
            setXevmpdData(updatedXevmpdPayload.xevmpdData.xevmpdFormData);
            setIntialFormData(updatedXevmpdPayload);
          }
        } catch (err) {
          enqueueSnackbar("Failed to update xEVMPD before saving", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
        }
      }

      // ✅ FIXED: Conditional file handling based on activeGridMenu
      let selectedFile: File | undefined = undefined;
      const basePayload = {
        xevmpdId: id,
        menu: activeGridMenu === "Acknowledgements" ? activeGridMenu : menuAndSectionDetails?.menuName,
        section: activeGridMenu === "Acknowledgements" ? activeGridMenu : menuAndSectionDetails?.sectionName, // ✅ Set section as menu name for all cases
        xevmpdRelatedData: sideFormData, // ✅ Start with just form data
      };

      // ✅ Only handle attachment file for Acknowledgements menu
      if (activeGridMenu === "Acknowledgements") {
        selectedFile = formValues.attachment?.rawFile ?? originalData?.rawFile ?? undefined;
        basePayload.xevmpdRelatedData.rawFile = selectedFile; // ✅ Add rawFile only for Acknowledgements
      }

      let response;
      if (sideFormMode === "edit") {
        // ✅ FIX #2: only include id when it exists
        if (activeGridMenu === "Acknowledgements") {
          response = await updateSideMenuRecord(
            {
              ...basePayload,
              ...(sideMenuRecordId ? { id: sideMenuRecordId } : {}),
              updatedBy: Cookies.get("USER_EMAIL"),
            },
            selectedFile // ✅ Pass file only for Acknowledgements (undefined for others)
          );
          getAuditDetails();
        }
        else {
          response = await updateSideMenuRecordV2(
            {
              ...basePayload,
              ...(sideMenuRecordId ? { id: sideMenuRecordId } : {}),
              updatedBy: Cookies.get("USER_EMAIL"),
            }
          );
        }
      } else if (sideFormMode === "add") {
        if (activeGridMenu === "Acknowledgements") {
          response = await addSideMenuRecord(
            {
              ...basePayload,
              createdBy: Cookies.get("USER_EMAIL")
            },
            selectedFile // ✅ Pass file only for Acknowledgements (undefined for others)
          );
          getAuditDetails();
        } else {
          response = await addSideMenuRecordV2(
            {
              ...basePayload,
              createdBy: Cookies.get("USER_EMAIL")
            })
        }
      }
      if (response?.success) {
        enqueueSnackbar(
          `${activeGridMenu === "Acknowledgements" ? "Acknowledgement" : menuAndSectionDetails.menuName} ${sideFormMode === "edit" ? "updated" : "added"} successfully`,
          { variant: "success" }
        );

        setLoading(false);
        if (isFormFlag) {
          setOriginalSideFormData(
            structureUpdatedData(basePayload.xevmpdRelatedData)
          );
          setSideFormMode("edit");
          setSideMenuRecordId(response.id);
          return;
        }

        if (!closeAfterSave) {
          const savedRecordId =
            response?.id != null
              ? String(response.id)
              : sideMenuRecordId
                ? String(sideMenuRecordId)
                : "";
          if (sideFormMode === "add" && response?.id != null) {
            setSideMenuRecordId(String(response.id));
            setSideFormMode("edit");
          }
          try {
            if (savedRecordId) {
              const rec = await getSideMenuRecord(Number(savedRecordId));
              const relatedData =
                typeof rec?.xevmpdRelatedData === "string"
                  ? JSON.parse(rec.xevmpdRelatedData || "{}")
                  : rec?.xevmpdRelatedData || {};
              const cellLike = { id: savedRecordId, ...relatedData };
              const forReset = transformFormDataForReset(
                cellLike,
                sideFormFields,
                relatedData
              );
              setOriginalSideFormData(structureUpdatedData(forReset));
              setSideFormData(forReset);
              reset(forReset);
            } else {
              const forReset = transformFormDataForReset(
                { ...updatedFormValues },
                sideFormFields,
                updatedFormValues
              );
              setOriginalSideFormData(structureUpdatedData(forReset));
              setSideFormData(forReset);
              reset(forReset);
            }
          } catch (e) {
            console.error("Failed to refresh side form after save", e);
            const forReset = transformFormDataForReset(
              { ...updatedFormValues },
              sideFormFields,
              updatedFormValues
            );
            setOriginalSideFormData(structureUpdatedData(forReset));
            setSideFormData(forReset);
            reset(forReset);
          }
          setacktrigger(!acktrigger);
          getAuditDetails();
          return;
        }

        setSideFormMode(null);
        setSideFormData({});
        reset(getDefaultSideFormValues());
        getAuditDetails();
      } else {
        enqueueSnackbar(
          `Failed to ${sideFormMode === "edit" ? "update" : "save"} record`,
          { variant: "error" }
        );
      }
      
      setacktrigger(!acktrigger);
    } finally {
      savingRef.current = false;
    }
  };


  // ✅ Wrapper inside component — keeps behavior same
  const handleFormsWrapper = async (
    formName: string | null,
    mode: "add" | "edit" | "view",
    cellData: any
  ) => {
    await handleForms(
      {
        id,
        xevmpdStatus,
        enqueueSnackbar,
        setLoading,
        setSideFormMode,
        setActiveGridMenu,
        setSideFormFields,
        setSideMenuRecordId,
        setSideFormData,
        reset,
        setOriginalSideFormData,
        setShowEditForm,
        setIsSideGrid,
        structureUpdatedData,
        setIsAssociatedGrid,
        isAssociatedGrid,
        sectionName: menuAndSectionDetails?.sectionName || "",
      },
      formName,
      mode,
      cellData
    );
  };

  const handleDisableConfirm = async (reason: any, comments: string) => {
    setLoading(true);
    const params = {
      reason: reason.id,
      comments: comments,
      updatedBy: Cookies.get("USER_EMAIL") || "",
    };
    const response = await disableRelatedRecord(params, selectedId);
    console.log("Disable Response:", response);
    if (response.status === 200)
      enqueueSnackbar(t(`${menuAndSectionDetails.menuName} deleted successfully`), {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    setOpenDisableDialog(false);
    setLoading(false);
    await getSideMenuGridData();
  };

  return (
    <>
      {/* Breadcrumbs */}
      <Grid
        sx={{
          // paddingLeft: "calc(var(--ff-space-spacious) / 2)",
          width: "100%",
          maxWidth: "100%",
          // overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            // paddingTop: "var(--ff-space-default)",
            maxWidth: "100%",
            margin: 0,
            boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
            height: "40px",
            position: "sticky",
            top: 0,
            zIndex: 1301,
            backgroundColor: "#fff",
          }}
        >
          <Grid item>
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              sx={{ paddingLeft: "calc(var(--ff-space-spacious) / 2)" }}
            >
              <Breadcrumbs
                separator={
                  <Typography component="span" sx={{ fontSize: "14px" }}>
                    /
                  </Typography>
                }
                aria-label="breadcrumb"
                className="Current-Page"
              >
                <Link
                  color="primary"
                  href="/xevmpd"
                  style={{ color: "#295ef1", fontWeight: 400 }}
                >
                  {t("xEVMPD")}
                </Link>

                {initialMode === "edit" && (
                  <Typography
                    component="span"
                    color="text.primary"
                    sx={{ fontSize: "14px" }}
                  >
                    {recordIDForBreadCrumbs}
                  </Typography>
                )}

                {initialMode === "view" && (
                  <Typography
                    component="span"
                    color="text.primary"
                    sx={{ fontSize: "14px" }}
                  >
                    {recordIDForBreadCrumbs}
                  </Typography>
                )}

                {showEditForm ? (
                  <Typography
                    component="span"
                    sx={{ color: "", fontSize: "14px" }}
                  >
                    {formMode === "edit" ? t("Edit xEVMPD") : t("View xEVMPD")}
                  </Typography>
                ) : (
                  <>
                    {sideFormMode ? (
                      <Link
                        color="primary"
                        underline="hover"
                        style={{
                          cursor: "pointer",
                          color: "#295ef1",
                          fontWeight: 400,
                        }}
                        onClick={async (e) => {
                          e.preventDefault();

                          setSideFormMode(null);
                          setShowEditForm(false);

                          if (pageTitle === "Acknowledgements") {
                            setIsSideGrid(false);
                            setActiveGridMenu(pageTitle);
                            await getSideMenuGridData();
                          } else {
                            setIsSideGrid(true);
                            setActiveGridMenu(pageTitle);
                            await loadSideMenuGridData(pageTitle, {
                              fetchAllSideMenuData,
                              handleForms: handleFormsWrapper,
                              setSideGridColumns,
                              setSideGridData,
                              setLoading,
                              intialformData,
                              id,
                            });
                          }
                        }}
                      >
                        {t(pageTitle)}
                      </Link>
                    ) : (
                      <Typography
                        component="span"
                        color="text.primary"
                        sx={{ fontSize: "14px" }}
                      >
                        {t(pageTitle)}{" "}
                      </Typography>
                    )}

                    {sideFormMode && (
                      <Typography
                        component="span"
                        color="text.primary"
                        sx={{ fontSize: "14px" }}
                      >
                        {sideFormMode === "add" &&
                          ` / Add ${t(activeGridMenu || pageTitle)}`}
                        {sideFormMode === "edit" &&
                          ` / Edit ${t(activeGridMenu || pageTitle)}`}
                        {sideFormMode === "view" &&
                          ` / View ${t(activeGridMenu || pageTitle)}`}
                      </Typography>
                    )}
                  </>
                )}
              </Breadcrumbs>
              <Divider orientation="vertical" flexItem />

              {/* Chips immediately to the right of breadcrumbs */}
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, ml: 1 }}
              >
                <Tooltip
                  title={
                    intialformData?.xevmpdData?.xevmpdFormData?.xevmpdStatus
                  }
                >
                  <Chip
                    label={
                      intialformData?.xevmpdData?.xevmpdFormData
                        ?.xevmpdStatus || "Draft"
                    }
                    size="small"
                    sx={{
                      backgroundColor: "#f1f2f4 !important",
                      // color: '#374151',
                      fontSize: "12px",
                      fontWeight: 500,
                      height: 24,
                      borderRadius: "16px",
                    }}
                  />
                </Tooltip>

                <Tooltip
                  title={`V${intialformData?.xevmpdData?.xevmpdFormData?.version}`}
                >
                  <Chip
                    label={`V${intialformData?.xevmpdData?.xevmpdFormData?.version || "V0.1"}`}
                    size="small"
                    sx={{
                      backgroundColor: "#f1f2f4  !important",
                      // color: '#405677ff !important',
                      fontSize: "12px",
                      fontWeight: 600,
                      height: 24,
                      borderRadius: "16px",
                      "& .MuiChip-label": {
                        paddingLeft: "8px",
                        paddingRight: "8px",
                      },
                    }}
                  />
                </Tooltip>
                {displayProcessTemplateName() && (
                  <Divider orientation="vertical" flexItem />
                )}
                {displayProcessTemplateName() && (
                  <Tooltip title={processTemplateName}>
                    <Chip
                      onClick={() => setProcessDrawerOpen(!processDrawerOpen)}
                      className={classNames(style["process-template-chip"])}
                      icon={<img alt="" src={inprogressIcon} />}
                      label={getTruncatedName(processTemplateName)}
                      variant="outlined"
                      size="small"
                    />
                  </Tooltip>
                )}
              </Box>
            </Box>
          </Grid>

          <Grid item>
            {/* Audit + Menu Row */}
            <Box display="flex" alignItems="center">
              {/* Audit Icon */}
              <ProcessIconButton
                xevmpdId={id}
                taskButtonConfig={taskButtonConfig}
                rows={allXevmpdRows}
                relatedProcessInfo={processRelatedInfo?.[id]}
                mode={initialMode}
                params={{}}
                recordID={recordIDForBreadCrumbs}
              ></ProcessIconButton>
              <Tooltip title={isExpand ? "Expand Menu" : "Collapse Menu"}>
                <IconButton
                  onClick={() => setIsExpand(!isExpand)}
                  // className={isExpand ? "menu-link expanded" : "menu-link"}
                  // style={{ marginLeft:"-12px" }}
                >
                  {isExpand ? (
                    <img src={ExpandMenuIcon} alt="Expand Menu" />
                  ) : (
                    <img src={CollapseMenuIcon} alt="Collapse Menu" />
                  )}
                  {/* <div style={{ marginLeft: "8px" }}>{t("Menu")}</div> */}
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
        </Grid>

        {/* Title & Chips */}

        {/* Main Layout */}
        <div
          style={{
            paddingLeft: "calc(var(--ff-space-spacious) / 2)",
            flex: 1,
            overflowY: "auto",
          }}
        >
          {!!processAssociationId && processJudge === "IN_PROGRESS" && (
            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                backgroundColor: "#fff",
              }}
            >
              <ProcessBarComponent
                xevmpdId={id}
                taskButtonConfig={taskButtonConfig}
              />
            </div>
          )}
          <div
            className="application-layouts"
            style={{
              marginTop:
                !!processAssociationId && processJudge === "IN_PROGRESS"
                  ? "85px"
                  : "10px",
                
            }}
          >
            <div className="menu-form">
              <Box className="main-page-title mb-24">
                <div
                  style={{ display: "flex", gap: "8px", alignItems: "center" }}
                >
                  <h1 className="page-title">
                    {showEditForm
                      ? t("xEVMPD Information")
                      : sideFormMode
                        ? `${t(`common.${sideFormMode}`)} ${t(activeGridMenu || pageTitle)}`
                        : t(pageTitle)}
                  </h1>
                  {/* {!viewOrEditPage && (<>
                  <RotatedTagChip
                    label={
                      params?.productName && params.productName.length > 20
                        ? params.productName.substring(0, 20) + "..."
                        : params?.productName || ""
                    }
                    tooltip={params?.productName}
                  />

                  <RotatedTagChip
                    label={params?.country || ""}
                    tooltip={params?.country}
                  /></>
                )}                 */}

                  {/* </Box> */}
                </div>
                <Box style={{ flex: "1 1 0%" }}></Box>

                {/* Right side */}
                {activeGridMenu && sideFormMode === null && (
                  <Box className="add_ack_btn">
                    {(pageTitle === "Acknowledgements"
                      ? privileges.addackprevilege
                      : true) &&
                      (initialMode === "edit" ||
                        intialformData?.xevmpdStatus === 1) &&
                      isAssociatedGrid && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            reset(getDefaultSideFormValues());
                            handleFormsWrapper(pageTitle, "add", {});
                          }}
                        >
                          {t("Add")} {t(activeGridMenu)}
                        </Button>
                      )}
                  </Box>
                )}
                {/* </Box> */}
              </Box>
              {/* Left Section */}
              <Grid item sx={{marginRight:"10px"}}>
                {loading ? (
                  // --- CASE 1: Loading ---
                  <Loading open={loading} />
                ) : isSideGrid ? (
                  // --- CASE 2: Side Grid Menus (Presentation, ATC, Product, etc.) ---
                  <>
                    <DataGridPremium
                      rows={sideGridData}
                      columns={sideGridColumns}
                      slots={{
                        toolbar: GridToolbar,
                        noRowsOverlay: NoRecordsFound,
                        noResultsOverlay: NoRecordsFound,
                      }}
                      localeText={localeText}
                      disableAggregation
                      disableRowSelectionOnClick
                      pagination
                      pageSizeOptions={[2, 10, 25, 50]} // ✅ Added 2 to remove warning
                      className="react-table table_size-has--row2"
                      initialState={{
                        pinnedColumns: { right: ["actions"] },
                        pagination: { paginationModel: { pageSize: 10 } },
                      }}
                      onStateChange={(state) => {
                        if (
                          Object.keys(state.columns.lookup || {}).length > 0 &&
                          sideGridData.length > 0
                        ) {
                          setTimeout(() => setIsGridReady(true), 300);
                        }
                      }}
                      sx={{
                        minHeight: 400,
                        height: "calc(100vh - 250px)",
                        "& .MuiDataGrid-pinnedColumnHeaders": {
                          backgroundColor: "#fff",
                          zIndex: 3,
                        },
                        "& .MuiDataGrid-pinnedColumns": {
                          backgroundColor: "#fff",
                          zIndex: 3,
                          ".MuiDataGrid-cell": { backgroundColor: "#fff" },
                        },
                        "& .MuiDataGrid-columnHeader--pinnedRight, & .MuiDataGrid-cell--pinnedRight":
                          {
                            justifyContent: "center",
                          },
                      }}
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                          csvOptions: { fileName: `${pageTitle}` },
                          excelOptions: { fileName: `${pageTitle}` },
                          printOptions: {
                            hideToolbarButton: false,
                            disableToolbarButton: false,
                            onBeforePrint: async () => {
                              await waitForGridReadyBeforePrint();
                              const gridRoot =
                                document.querySelector(".MuiDataGrid-root");
                              if (gridRoot) {
                                gridRoot.classList.add("print-mode");
                              }
                              await new Promise((resolve) =>
                                setTimeout(resolve, 150),
                              );
                            },
                            onAfterPrint: () => {
                              const gridRoot =
                                document.querySelector(".MuiDataGrid-root");
                              if (gridRoot) {
                                gridRoot.classList.remove("print-mode");
                              }
                            },
                          },
                        },
                      }}
                    />
                    <CreationUpdateDetails
                      details={details}
                    ></CreationUpdateDetails>
                  </>
                ) : activeGridMenu ? (
                  // --- CASE 3: Acknowledgements (existing working flow) ---
                  sideFormMode ? (
                    // Add/Edit/View acknowledgement form
                    sideFormMode === "view" ? (
                      <>
                        {(() => {
                          // ✅ Fix only for Acknowledgement view:
                          // Prevent rendering attachment object directly
                          const safeData = { ...sideFormData };
                          if (
                            pageTitle === "Acknowledgements" &&
                            safeData?.attachment &&
                            typeof safeData.attachment === "object" &&
                            safeData.attachment.name
                          ) {
                            safeData.attachment = safeData.attachment.name;
                          }

                          return (
                            <div className="span-space-mr">
                              <DynamicFormCompBasicJsonSchema
                                jsonData={sideFormFields}
                                initialFormData={safeData}
                                removeButtons
                                viewType
                              />
                            </div>
                          );
                        })()}

                        <Box display="flex" justifyContent="flex-end" mt={2}>
                          <Button
                            onClick={handleSideFormCancel}
                            color="primary"
                          >
                            {t("cancel")}
                          </Button>
                          {/* {!!processAssociationId && processJudge !== "NOT_STARTED" && !isAssociatedGrid && (<ProcessButton  ref={processButtonRef}
                                  taskButtonConfig={taskButtonConfig} xevmpdId={id}></ProcessButton>)} */}
                        </Box>
                        <CreationUpdateDetails
                          details={details}
                        ></CreationUpdateDetails>
                      </>
                    ) : (
                      <EditForm
                        formFields={sideFormFields}
                        control={control}
                        register={register}
                        watch={watch}
                        isNotDraftState={isNotDraftState}
                        errors={errors}
                        trigger={trigger}
                        clearErrors={clearErrors}
                        setError={setError}
                        setValue={setValue}
                        intialformData={sideFormData}
                        formMode={sideFormMode}
                        onCancel={handleSideFormCancel}
                        onSave={() =>
                          void handleSaveSideMenuData(
                            sideFormData,
                            /* add: return to grid like before; edit: stay on form */
                            sideFormMode === "add"
                          )
                        }
                        {...(sideFormMode === "edit"
                          ? {
                              onSaveAndClose: () =>
                                void handleSaveSideMenuData(sideFormData, true),
                            }
                          : {})}
                        isFormModified={isFormModified}
                        isFormFlag={isFormFlag}
                        processJudge={processJudge}
                        processAssociationId={processAssociationId}
                        xevmpdId={id}
                        details={details}
                      />
                    )
                  ) : (
                    // Acknowledgement grid view
                    <>
                      <DataGridPremium
                        checkboxSelection={false}
                        columns={columns}
                        rows={AckRows}
                        className="react-table table_size-has--row2"
                        slots={{
                          toolbar: GridToolbar,
                          noRowsOverlay: NoRecordsFound,
                          noResultsOverlay: NoRecordsFound,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        initialState={{
                          pinnedColumns: { right: ["actions"] },
                          pagination: { paginationModel: { pageSize: 25 } },
                        }}
                        slotProps={{
                          toolbar: {
                            csvOptions: { fileName: "Acknowledgements" },
                            excelOptions: { fileName: "Acknowledgements" },
                            filterModel: true,
                            showQuickFilter: true,
                            sx: {
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              position: "relative",
                            },
                          },
                        }}
                        localeText={localeText}
                        disableAggregation
                        onColumnVisibilityModelChange={(newModel) =>
                          setColumnVisibilityModel(newModel)
                        }
                        pagination
                      />
                      <CreationUpdateDetails
                        details={details}
                      ></CreationUpdateDetails>
                    </>
                  )
                ) : formMode === "view" ? (
                  // --- CASE 4: View Mode (xEVMPD or single-form menus) ---
                  <div className="span-space-mr">
                    <DynamicFormCompBasicJsonSchema
                      jsonData={
                        pageTitle === "xEVMPD"
                          ? formFields
                          : sideMenuData.fieldData
                      }
                      initialFormData={
                        pageTitle === "xEVMPD"
                          ? { ...intialformData?.xevmpdData?.xevmpdFormData,
                             recordID: recordIDForBreadCrumbs }
                          : sideMenuData.formData
                      }
                      removeButtons
                      viewType={true}
                    />

                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      mt={2}
                      sx={{ marginTop: "var(--ff-space-spacious)" }}
                    >
                      {pageTitle === "xEVMPD" && (
                        <Button
                          onClick={() => navigate("/xevmpd")}
                          color="primary"
                        >
                          {" "}
                          {t("cancel")}{" "}
                        </Button>
                      )}
                      {pageTitle === "xEVMPD" &&
                        (intialformData.xevmpdStatus === 0 ||
                          intialformData.xevmpdStatus === 2) &&
                        privileges.editprivilege &&
                        applicationEditable && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              // reset(transformFormDataForReset(xevmpdData, formFields));
                              setFormMode("edit");
                            }}
                          >
                            {t("edit")}
                          </Button>
                        )}

                      {pageTitle !== "xEVMPD" && (
                        // <Box display="flex" justifyContent="flex-end">
                        <Button
                          onClick={() => navigate("/xevmpd")}
                          color="primary"
                        >
                          {t("cancel")}
                        </Button>
                        // </Box>
                      )}

                      {/* {!!processAssociationId && processJudge !== "NOT_STARTED" && (<ProcessButton  ref={processButtonRef}
                                  taskButtonConfig={taskButtonConfig} xevmpdId={id}></ProcessButton>)} */}
                    </Box>
                    <CreationUpdateDetails
                      details={details}
                    ></CreationUpdateDetails>
                  </div>
                ) : (
                  // --- CASE 5: Edit xEVMPD ---
                  <EditForm
                    formFields={formFields}
                    control={control}
                    watch={watch}
                    register={register}
                    isNotDraftState={isNotDraftState}
                    errors={errors}
                    trigger={trigger}
                    clearErrors={clearErrors}
                    setError={setError}
                    setValue={setValue}
                    intialformData={{ ...xevmpdData, recordID: recordIDForBreadCrumbs }}
                    formMode={formMode}
                    onCancel={() => navigate("/xevmpd")}
                    onSave={() => void handleSave(false)}
                    onSaveAndClose={() => void handleSave(true)}
                    isFormModified={isFormModified}
                    isFormFlag={isFormFlag}
                    processJudge={processJudge}
                    processAssociationId={processAssociationId}
                    xevmpdId={id}
                    details={details}
                    recordID={recordIDForBreadCrumbs}
                  />
                )}
              </Grid>
              {/* <CreationUpdateDetails details={details}></CreationUpdateDetails>} */}
            </div>

            {/* Right Section */}
            <div
              className="custom-collapse-menu"
              style={isExpand ? { display: "none" } : {}}
            >
              <Grid item sx={{ mt: -7 }}>
                {/* Side Navigation */}
                <Stack
                  className="custom-collapse-menu"
                  style={isExpand ? { display: "none" } : { marginTop: "0px" }}
                >
                  <SideNavigation
                    onChange={checkForModifications}
                    menuData={sideMenus}
                    onRevertSelection={(restoreFn: () => void) => {
                      revertSelectionRef.current = restoreFn;
                    }}
                  />
                </Stack>
              </Grid>
            </div>
          </div>
        </div>
      </Grid>
      <DeletexEVMPD
        open={openDisableDialog}
        setOpen={setOpenDisableDialog}
        handleDeleteConfirm={handleDisableConfirm}
        isSideMenu={true}
        menuName={activeGridMenu ?? pageTitle}
      />
      <Dialog
        open={showNavigationConfirm}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setShowNavigationConfirm(false);
          }
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(15, 15, 15, 0.4) !important",
            },
          },
        }}
      >
        <DialogTitle>Unsaved Changes</DialogTitle>
        <DialogContent>
          <Typography>
            Any changes made to the xEVMPD data will be lost. Do you wish to
            continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowNavigationConfirm(false);
              // setNavigateToOtherMenu(false);
              // revert side menu highlight if available
              if (revertSelectionRef.current) {
                revertSelectionRef.current();
              }
            }}
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => {
              setShowNavigationConfirm(false);
              setIsFormModified(false); // ✅ Important: stop popup from reappearing
              setNavigateToOtherMenu(true);
              // if (revertSelectionRef.current) revertSelectionRef.current();
            }}
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditxEVMPD;
